module.exports = __webpack_public_path__ + "static/media/sopt18ru.892f9764.pdf";